import { useSelectedLocation } from "components/DealersAndLocationsDropdown/hooks";
import { useTypedQuery } from "hooks";
import { AppointmentsQueryKeys } from "modules/Appointments/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Car } from "models";

type SearchCarProps = {
  regNr: string;
};

const mapCars = (cars: Car[]) =>
  cars.map(({ id, reg_nr, vin_nr, make, model, dms_nr, apk_date_dms }) => ({
    id,
    key: id,
    title: `${reg_nr || ""} - ${make || ""} - ${model || ""}`,
    car: { id, reg_nr, vin_nr, make, model, dms_nr, apk_date_dms }
  }));

export const useSearchCarQuery = ({ regNr }: SearchCarProps) => {
  const { selectedLocation } = useSelectedLocation();

  return useTypedQuery({
    queryKey: AppointmentsQueryKeys.searchCars,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.post(endpoint, { reg_nr: regNr, location_id: selectedLocation?.id }, baseUrl)).data.cars,
    enabled: false,
    select: mapCars
  });
};
